import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IMobileSecuritySetting } from '../types/IMobileSecuritySettings';

export interface ISetMobileSecuritySettingsForServerSettingsParams {
  settings: IMobileSecuritySetting[];
}

export type ISetMobileSecuritySettingsForServerSettingsResult = IResult;

export class SetMobileSecuritySettingsForServerRequest extends Request<ISetMobileSecuritySettingsForServerSettingsParams, ISetMobileSecuritySettingsForServerSettingsResult> {
  constructor(params: ISetMobileSecuritySettingsForServerSettingsParams) {
    super('setMobileSecuritySettingsForServer', params);
  }
}
